import React, { useContext } from "react";
import { Songs } from "../../../Context/ContextApp";

export default function DetailSong() {
  const { song } = useContext(Songs);
  return (
    <div className="col-span-1 p-3 bg-slate-700">
      <div className="text-[#38bdf8] font-bold">Now playing</div>
      <div className="text-2xl">{song.name}</div>
      <div className="flex items-center justify-center mt-16">
        <img
          className="w-64"
          src={song.links?.images[0].url}
          alt="avatar"
        />
      </div>
      <div className="flex justify-evenly items-center h-24">
        <img
          className="w-16 rounded-full"
          src={song.links?.images[1].url}
          alt="logo"
        />
        <span className="text-xl text-white">{song.author}</span>
      </div>
    </div>
  );
}
